<mat-grid-list [ngClass]="customClass||''" [cols]="gridCols" [gutterSize]="'6px'" [rowHeight]="rowHeight" [style.--tab-font-size]="fontNameSize + 'px'">
    @if(itemsFavorite) {
        <mat-grid-tile class="tw-cursor-pointer tw-rounded-md tw-text-sm"
            [ngClass]="{
                'category-grid__selected': _categorySelected === 'favorites',
                'not-favorite-selected': _categorySelected !== 'favorites'
            }"
            (click)="emitCategorySelection({ id: -1, name: 'favorite' })">
            {{'CASHREGISTER.SHOWCASE.FAVOURITES' | translate }}
        </mat-grid-tile>
    }
    @for(category of categoriesSet; track category) {
        <mat-grid-tile
            [attr.id]="'cat_' + category.id"
            class="tw-cursor-pointer tw-rounded-md tw-text-sm"
            tilbyGestures
            (click)="emitCategorySelection(category)"
            [style.--category-bg-color]="'#' + (category.color || 'b2dfdb')"
            [ngClass]="{
                'category-grid__selected': _categorySelected !== 'favorites' && category.id === _categorySelected?.id,
                'custom-bg-color': _categorySelected === 'favorites' || category.id !== _categorySelected?.id
            }">
            {{ category.name }}
        </mat-grid-tile>
    }
</mat-grid-list>
